import React from 'react';
import {
  Modal,
  Text,
  Box
} from '@amount/frontend-components';

/**
 * GE-3271: transient interstitial shown on the *recoverable* re-auth path
 * (token_expired / no_token) while the login/handoff silently re-mints a fresh
 * cookie. Deliberately has no "log in" call to action — the user is not being
 * asked for credentials, the session is reconnecting on its own. The genuine
 * "please log in" prompt lives in LoggedOut and is reserved for the
 * non-recoverable path.
 */
export const Reconnecting: React.FunctionComponent = () => {
  const reconnectingConfig = AvantConfig.TenantConfig.session.reconnecting;

  return (
    <Modal
      isShown={true}
      ariaModal={true}
      ariaLabelledby='reconnecting-modal'
      cardWidth={{ max: 'narrow' }}
      // The interstitial is not user-dismissable — the page is mid-redirect —
      // but Modal requires a close handler, so provide a no-op.
      handleModalClose={() => undefined}
      heading={{
        text: reconnectingConfig.headingText,
        styles: {
          align: 'center',
          family: 'optimist_light',
          lineHeight: '1.2',
          margin: { horizontal: 'auto' },
          size: 'heroLarge',
        }
      }}
    >
      <Box margin={{ top: '3x', bottom: '4x' }} direction='column'>
        {/*
          Iterate with Object.values(): the webpack AvantConfig injection
          serializes the source `bodyText: [...]` array into an object with
          numeric keys (`{ 0: '...' }`) in the production bundle, so calling
          `.map()` on it directly throws `bodyText.map is not a function` and
          strands the bootstrap re-auth render (GE-3271). This mirrors the
          proven pattern in the sibling LoggedOut component and is robust to
          both the array (test) and object (prod) shapes.
        */}
        {Object.values(reconnectingConfig.bodyText).map((bodyText, idx) => (
          <Text key={`reconnecting-text-${idx}`} lineHeight='1.5' align='center'>
            {bodyText}
          </Text>
        ))}
      </Box>
    </Modal>
  );
};
